module.exports = __webpack_public_path__ + "img/slider-left.423cf4f8.svg";